<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 215 301"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M.726074 301V0H210.337v37.5208H48.5835v-5.8366c0-1.6676-.4877-2.9878-1.463-3.9605-.8359-1.1117-2.0202-1.6676-3.5527-1.6676-1.3932 0-2.6471.5559-3.7617 1.6676-.9752 1.1117-1.4628 2.4319-1.4628 3.9605-1.6719 0-3.0652.4864-4.1798 1.4592-.9752.8337-1.4628 2.015-1.4628 3.5436s.6269 2.7793 1.8808 3.7521c1.2539.9727 2.7865 1.4591 4.5977 1.4591h5.2246v84.0048H198.843v36.687H48.5835v-5.837c0-1.667-.4877-2.987-1.463-3.96-.8359-1.112-2.0202-1.668-3.5527-1.668-1.3932 0-2.6471.556-3.7617 1.668-.9752 1.112-1.4628 2.432-1.4628 3.96-1.6719 0-3.0652.487-4.1798 1.46-.9752.833-1.4628 2.015-1.4628 3.543 0 1.529.6269 2.78 1.8808 3.752 1.2539.973 2.7865 1.459 4.5977 1.459h5.2246v92.135h-5.2246c-1.8112 0-3.3438.486-4.5977 1.459-1.2539.973-1.8808 2.223-1.8808 3.752s.4876 2.779 1.4628 3.752c1.1146.834 2.5079 1.251 4.1798 1.251 0 1.528.4876 2.849 1.4628 3.96 1.1146 1.112 2.3685 1.668 3.7617 1.668 1.5325 0 2.7168-.486 3.5527-1.459.9753-1.112 1.463-2.502 1.463-4.169v-5.837H214.726V301H.726074Z"
      fill="currentColor"
    />
  </svg>
</template>
